import { AssetController } from '../controllers/AssetController.js';
export const AssetUtil = {
  getWalletImage(wallet) {
    if (wallet !== null && wallet !== void 0 && wallet.image_url) {
      return wallet === null || wallet === void 0 ? void 0 : wallet.image_url;
    }
    if (wallet !== null && wallet !== void 0 && wallet.image_id) {
      return AssetController.state.walletImages[wallet.image_id];
    }
    return undefined;
  },
  getNetworkImage(network) {
    if (network !== null && network !== void 0 && network.imageUrl) {
      return network === null || network === void 0 ? void 0 : network.imageUrl;
    }
    if (network !== null && network !== void 0 && network.imageId) {
      return AssetController.state.networkImages[network.imageId];
    }
    return undefined;
  },
  getConnectorImage(connector) {
    if (connector !== null && connector !== void 0 && connector.imageUrl) {
      return connector.imageUrl;
    }
    if (connector !== null && connector !== void 0 && connector.imageId) {
      return AssetController.state.connectorImages[connector.imageId];
    }
    return undefined;
  }
};
//# sourceMappingURL=AssetUtil.js.map